import _objectSpread from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "Container"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, { Children, Fragment } from 'react';
import MarkedListItem from './MarkedListItem';
import useMarkedList from './useMarkedList';
/**
 * A component which given a counter style, wraps each of its children with a
 * {@link MarkedListItem}. The latter prepends the child with a marker
 * box containing a marker string representation for this child index.
 *
 * See {@link https://www.w3.org/TR/css-lists-3/#markers | CSS Lists and Counters Module Level 3, Markers}.
 *
 * @public
 */

export default function MarkedList(_ref) {
  var children = _ref.children,
    _ref$Container = _ref.Container,
    Container = _ref$Container === void 0 ? Fragment : _ref$Container,
    props = _objectWithoutProperties(_ref, _excluded);
  var normalChildren = Children.toArray(children);
  var listProps = useMarkedList(_objectSpread(_objectSpread({}, props), {}, {
    length: normalChildren.length
  }));
  return /*#__PURE__*/React.createElement(Container, {}, normalChildren.map(function (child, index) {
    return /*#__PURE__*/React.createElement(MarkedListItem, _extends({
      key: index,
      index: index
    }, listProps), child);
  }));
}